<template>
<div class="chapter">
<div class="inner_page">
<div id="V4305ebook-3.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CT para-style-override-1" id="toc_marker-4"><span class="char-style-override-4">SWEET</span></p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-5">SUNDAY</span></p>
<p class="Basic-Paragraph para-style-override-3"><span class="char-style-override-6">John Lawton</span></p>
<p class="BT-1st-Para para-style-override-4"><img alt="L-1.tif" class="image" src="images/L-1_fmt.png" width="8%"/></p>
<p class="BT-1st-Para para-style-override-2">Atlantic Monthly Press</p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-3">New York</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// V4305ebook3.vue?f75f08c2